// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.
module.exports = {
  newInvalidAsn1Error: function newInvalidAsn1Error(msg) {
    var e = new Error();
    e.name = 'InvalidAsn1Error';
    e.message = msg || '';
    return e;
  }
};